import environment from '../../../environments/environment';  
import { axiosInterceptor } from './authInterceptor';



export async function getMenuItemsByClientId(clientId: number) {
   try {
    return await axiosInterceptor.get(`${environment.menuItemsURL}?clientId=${clientId}`);
  } catch (error: any) {
    return error; // instead of throwing
  }
}
